<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class>
        <h5 class="form-header">Listado de Productos de la Lista de Precios</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'cat-lista_precios-nueva', params: {  }}"
              >
                <i class="fa fa-plus"></i>
                Agregar Producto
              </router-link>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
              >Refresh</a>
            </div>
          </div>
          <PrecioProductoListadoComponent v-if="current.id != 0" :lista_precio="current.id"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ListaPrecioFormComponent from "@/components/cat/lista_precios/ListaPrecioFormComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import Notifications from "@/notifications/notifications";
import PrecioProductoListadoComponent from "@/components/cat/lista_precios/PrecioProductoListadoComponent";

export default {
  components: {
    PaginationComponent,
    ListaPrecioFormComponent,
    PrecioProductoListadoComponent
  },
  data() {
    return {
      current: {
        id: 0,
        nombre: "",
        errors: {
          nombre: []
        }
      },
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: null,
      data: [],
      selected: {},
      productoSeleccionado: {}
    };
  },
  mounted() {
    let self = this;
    if (self.$route.params.id) {
      ListaPreciosService.getById(self.$route.params.id).then(response => {
        self.current = response.data;
        self.current.errors = [];
      });
    }
    self.refreshData();
    // self.refreshDataProductos();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo
      });
    },

    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo
      });
    },

    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},

    refreshData(params) {
      let self = this;
      ListaPreciosService.fetch(params).then(res => {
        self.data = res.data;
      });
    },
    mostrarModalListaPrecioForm() {
      let self = this;
    },
    abrirModalListaPrecio(current) {
      let self = this;
      // self.selected =
      this.$store.dispatch("listaprecios/set", current);
      /*
            self.selected = current;
            Vue.nextTick(function () {
                })
            self.mostrarModalListaPrecioForm();
            */
      $("#modalFormListaPrecio").modal();
    },
    
  }
};
</script>
